import React from 'react';
import GoldenTides from '../contents/dev/GoldenTides.png';
import Necromantic from '../contents/dev/Necromantic_new.png';
import Polystrike from '../contents/dev/Polystrike_new.png';
import {Link} from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Home() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        accessibility: true,
        adaptiveHeight: true,
        draggable: false,
        swipe: false,
        touchMove: false,
        centerMode: false,       // must be false
        variableWidth: false,    // must be false
        fade: true,             // 👈 Enables fade effect
        cssEase: "linear",      // Optional: controls easing
    };


    return (
        <div>
            <div className="relative bg-black ">
                <div className="sm:block hidden absolute inset-0 z-10 pointer-events-none"
                     style={{
                         background: "linear-gradient(to left, rgba(255,255,255,0), rgba(0,0,0,0.75) 60%)",
                     }}
                />
                <div className="w-full h-1/4">
                    <Slider {...settings} className="w-full sm:h-screen h-1/4">
                        {[GoldenTides, Necromantic, Polystrike].map((imgSrc, idx) => (
                            <div key={idx} className="image-grad w-screen sm:h-screen h-1/4">
                                <img
                                    style={{
                                        zIndex: 1
                                    }}
                                    src={imgSrc}
                                    alt={`Slide ${idx + 1}`}
                                    className="relative w-full h-full object-cover"
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Overlay content for desktop */}
                <div style={{
                    zIndex: 11
                }}
                     className="content hidden sm:flex absolute inset-0 items-center px-8 sm:px-10 md:px-20 lg:px-32 2xl:px-40 text-white">
                    <div className="space-y-16">
                        <div className="home-main-text-under text-space">
                            <div>
                                3Dot<span className="text-yellow-400">Studio</span> is a team of game developers
                            </div>
                            <div>with over a decade of experience.</div>
                            <div>Partnering with a team of artists, we deliver</div>
                            <div>unforgettable games, from concept to launch.</div>
                        </div>

                        <div className="text-xl sm:text-3xl font-light">
                            Our other passion is web 3D applications
                        </div>
                        <div>
                            <Link to="/web">
                                <button
                                    className="h-14 sm:w-64 w-full rounded-md text-xl text-black bg-yellow-400 shadow-xl">
                                    <span>Web 3D</span>
                                </button>
                            </Link>
                        </div>


                    </div>
                </div>

                {/* Separate block for mobile */}
                <div className="sm:hidden px-6 text-white space-y-8 bg-black py-6">
                    <div className="text-2xl font-bold">
                        <div>
                            3Dot<span className="text-yellow-400">Studio</span> is a team of game developers
                        </div>
                        <div>with over a decade of experience.</div>
                        <div>Partnering with a team of artists, we deliver</div>
                        <div>unforgettable games, from concept to launch.</div>
                    </div>
                    <div className="text-lg font-light">
                        Our other passion is web 3D applications
                    </div>
                    <div>
                        <Link to="/web">
                            <button className="h-14 w-full rounded-md text-xl text-black bg-yellow-400 shadow-xl">
                                <span>Web 3D</span>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}